import React from 'react';
import PrivacyPolicy from '../components/PrivacyPolicy';

const EmployeePrivacyPolicy = () => {
  return <PrivacyPolicy appType="employee" />;
};

export default EmployeePrivacyPolicy;
